import AnswerText from './AnswerText';
import NoAnswer from './NoAnswer';

interface BooleanAnswerProps {
    answer: boolean | string;
}

const BooleanAnswer: React.FC<BooleanAnswerProps> = ({ answer }) => {
    const stringValue = String(answer).toLowerCase();

    if (stringValue === 'true' || stringValue === 'false') {
        const booleanValue = stringValue === 'true';
        return <AnswerText sx={{ fontWeight: 'medium' }}>{booleanValue ? 'Yes' : 'No'}</AnswerText>;
    }

    return <NoAnswer />;
};

export default BooleanAnswer;
